module.exports = __webpack_public_path__ + "static/media/sub-card-label-1-over.1cb8cc50.svg";